import { gql } from '@apollo/client'
import { ORDER_NODE } from '../fragments/order.fragment'
import { META_FRAGMENT } from '../fragments/filters.fragment'

export const GET_ORDERS = gql`
  query GetOrders($input: OrdersInput) {
    orders(input: $input) {
      meta {
        ...MetaNode
      }
      data {
        ...OrderNode
      }
    }
  }
  ${ORDER_NODE}
  ${META_FRAGMENT}
`

export const GET_ORDER_URL = gql`
  query orderInvoiceUrl($input: OrdersInvoiceUrlInput) {
    orderInvoiceUrl(input: $input) {
      url
    }
  }
`
